import { FilterManager, listFilters, KlevuFetchModifer } from "@klevu/core";
import { KlevuSliderFiltersKeys } from "../../catalog/variables/KlevuSliderFiltersKeys";

export function prepareKlevuListFilters(
  filterManager: FilterManager,
  include?: string[],
): KlevuFetchModifer {
  return listFilters({
    limit: -1,
    rangeFilterSettings: [
      {
        key: "klevu_price",
        minMax: true,
      },
      ...KlevuSliderFiltersKeys.filter(
        (key) => !include || include?.includes(key),
      ).map((key) => ({
        key,
        minMax: true,
      })),
    ],
    ...(include?.length ? { include } : {}),
    filterManager,
  });
}
